import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enCommon from "locales/en/common.json";
import enNavigation from "locales/en/navigation.json";
import enForecast from "locales/en/forecast.json";
import enPages from "locales/en/pages.json";
import enHelp from "locales/en/help.json";
import jaCommon from "locales/ja/common.json";
import jaNavigation from "locales/ja/navigation.json";
import jaForecast from "locales/ja/forecast.json";
import jaPages from "locales/ja/pages.json";
import jaHelp from "locales/ja/help.json";

export const supportedLanguages = ["en", "ja"];
export const languageLabels = {
  en: "English",
  ja: "日本語",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        navigation: enNavigation,
        forecast: enForecast,
        pages: enPages,
        help: enHelp,
      },
      ja: {
        common: jaCommon,
        navigation: jaNavigation,
        forecast: jaForecast,
        pages: jaPages,
        help: jaHelp,
      },
    },
    supportedLngs: supportedLanguages,
    fallbackLng: "en",
    load: "languageOnly",
    ns: ["common", "navigation", "forecast", "pages", "help"],
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "locale",
    },
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.resolvedLanguage || "en";
  i18n.on("languageChanged", (language) => {
    document.documentElement.lang = language;
  });
}

export default i18n;
